<template>
  <section class="container-fluid py-6 py-md-7" id="advisory-services">
    <FAapproach/>
    <FAgallery/>
    <FAindustry/>
    <FAtransactions/>
  </section>
</template>

<script>
import FAapproach from "@/components/FAapproach.vue";
import FAgallery from "@/components/FAgallery.vue";
import FAindustry from "@/components/FAindustry.vue";
import FAtransactions from "@/components/FAtransactions.vue";
export default {
  components: {
    FAapproach,
    FAgallery,
    FAindustry,
    FAtransactions
  }
};
</script>

<style lang="scss" scoped></style>
